import './styles.scss'
import { Pulse } from '../../models/settings'
import { fieldMap, stateNames } from '../stats-ticker/mappings'
import queue from 'async/queue';

const dateStr = (daydelta=0) => {
  const d = new Date()
  d.setDate(d.getDate() + daydelta)
  const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d)
  const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d)
  return `${mo}/${da}`
}


const abbreviateNumber = (number) => {
  var SI_SYMBOL = ["", "K", "M", "G", "T", "P", "E"];

  // what tier? (determines SI symbol)
  var tier = Math.log10(number) / 3 | 0;

  // if zero, we don't need a suffix
  if(tier == 0) return number;

  // get suffix and determine scale
  var suffix = SI_SYMBOL[tier];
  var scale = Math.pow(10, tier * 3);

  // scale the number
  var scaled = number / scale;

  // format number and add suffix
  return scaled.toFixed(1) + suffix;
}



const card = (stats={}) => {
  const {
    title, result={},
  } = stats
  const { data={} } = result
  delete data.country
  delete data.county
  delete data.state
  const date = data.dt || dateStr(-1)
  const cases = ['caseperm', 'total', 'cases', 'newcases', 'avgrate7']
  const deaths = ['deathperm', 'death', 'deaths', 'newdeath', 'newdeaths']
  const tests = ['testperm', 'positiverate', 'recoverrate', 'deathrate' , /*'deathpktest'*/ 'weekrate3', 'weekrate7']

  const renderStat = (field, i) => {
    let value = data[field]

    return value && m('ons-col.stat', [
      m('.heading', fieldMap[field]),
      m('.value', value > 1e3 ? abbreviateNumber(value) : (value + '').replace(' ', '')),
    ])
  }
  const pad = (arr) => {
    arr = arr.filter(x => x)
    while (arr.length < 3) {
      arr.push(m('ons-col.stat'))
    }
    return arr
  }

  return m("ons-card", [
    m("div.title",
      title,
      stats.chart &&
      m("ons-icon.pull-right[icon='fa-bar-chart']", {
        onclick: () => stats.pushCharts({
          ...stats,
          geoName: stateNames[stats.id] || stats.id
        })
      })
    ),
    m("div.content",
      m('ons-row.cases.row', pad(cases.map(renderStat))),
      m('ons-row.deaths.row', pad(deaths.map(renderStat))),
      m('ons-row.tests.row', pad(tests.map(renderStat))),
    )
  ])
}

const CustomStats = () => {
  let data
  var q = queue(async (stat, callback) => {
    let result
    if(stat.geo) {
      result = await m.request({
        method: "GET",
        url: "/data/",
        background: true,
        params: { key: stat.geo, yesterday: 1 }
      })
      result = {
        data: result.data.find(row => row.country === stat.id || row.state === stat.id || row.metro === stat.id),
        chart: result.charts[stat.id]
      }
    }
    else if(stat.state) {
      result = await m.request({
        method: "GET",
        url: "/data/county",
        background: true,
        params: { state: stat.state, yesterday: 1 }
      })
      result = {
        data: result.data.find(row => row.county === stat.id)
      }
    }
    callback(result);
  }, 2);

  return {
    oninit: async (vnode) => {
      const vals = await Pulse.fetch()
      data = Object.values(vals)
      m.redraw()

      data.forEach((stat, i) => {
        q.push(stat, (result) => {
          data[i].result = result
          m.redraw()
        })
      })
    },
    view: (vnode) => {
      return m('.custom-stats',
        data &&
        data.map(stat => {
          let title = stat.id
          console.log(stat)
          if(stat.metro) {
            title += ` Metro`
          }
          if(stat.state) {
            title += ` County, ${stat.state}`
          }
          if(stat.geo === 'USA') {
            title = stateNames[stat.id]
          }
          return card({ ...vnode.attrs, ...stat, title, result: stat.result })
        }),
        data && data.length === 0 &&
        m('.empty', [
          m('em', `You aren't tracking any places!`),
          m('p', `Pin specific places to this screen by selecting rows from the World and USA tabs above.`)
        ])
      )
    }
  }
}

export default CustomStats
export { card }
